module.exports = __webpack_public_path__ + "img/image_en.456e689.png";